import axios from "axios";

import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";

export function useQuota() {
  const [data, setData] = useState({
    used: 0,
    total: 0,
  });

  const { status } = useSession();

  async function fetchData() {
    if (status === "authenticated") {
      const { data } = await axios.get("/api/quota");
      setData(data);
    }
  }

  useEffect(() => {
    fetchData();
  }, [status]);
  return { refresh: fetchData, ...data };
}
